/**
 * AppBackdrop — fondo de la app (identidad v2.1): placa de concreto con retícula y un
 * atleta muy tenue en luminosidad que se funde al asfalto. Va detrás de todo el
 * contenido de los layouts (regla 70/30: ameniza sin competir con los datos).
 */
const PHOTOS = {
  user: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?auto=format&fit=crop&w=1200&q=55',
  coach: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1200&q=55',
  admin: 'https://images.unsplash.com/photo-1574680096145-d05b474e2155?auto=format&fit=crop&w=1200&q=55',
};

const AppBackdrop = ({ variant = 'user' }) => (
  <div aria-hidden="true" className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-testid="app-backdrop">
    <div className="plate-bg" />
    <div
      className="absolute inset-x-0 top-0 h-[70vh] bg-cover bg-[center_30%] opacity-[.09] onor-kb"
      style={{ backgroundImage: `url('${PHOTOS[variant] || PHOTOS.user}')`, mixBlendMode: 'luminosity' }}
    />
    <div className="absolute inset-x-0 top-0 h-[70vh]" style={{ background: 'linear-gradient(180deg, rgba(11,12,14,.35) 0%, rgba(11,12,14,.7) 55%, #0B0C0E 100%)' }} />
  </div>
);

export default AppBackdrop;
